import React, { useCallback } from 'react';
import TextInput from '../../../../../common/components/TextInput';
import PageSelector from '../../../../../common/components/PageSelector/PageSelector';
import './LandingPageProperties.scss';


const TextInputBase =
  ({ value, onNameChange, validateInput, inputName, placeholder, errorMessage }) =>
    <div className="landing-page-properties__input-container">
      <div className="landing-page-properties__name-container">
        <div className="landing-page-properties__field-title">{inputName}</div>
        <TextInput
          placeholder={placeholder}
          className="landing-page-properties__name"
          maxLength="50"
          onChange={onNameChange}
          onBlur={validateInput}
          value={value}
        />
        {errorMessage &&
          <div className="landing-page-properties__error">
            {errorMessage}
          </div>
        }
      </div>
    </div>;

const LandingPageProperties = props => {
  const {
    formName,
    updateFormName,
    formLinkSlug,
    updateFormLinkSlug,
    formLinkSlugError,
    validateLinkSlug,
    formPageId,
    updateFormPageId,
    formLink,
  } = props;

  const pageSelectorProps = {
    selectedPageId: formPageId,
    updateFormPageId,
  };

  const trimUnusedCharacters = useCallback((e) => {
    e.target.value = e.target.value.replace(/[^A-Za-z0-9-_]+/g, '');
  }, []);

  return (
    <div>
      <TextInputBase
        value={formName}
        onNameChange={e => updateFormName(e.target.value)}
        inputName="Name"
        placeholder="Landing page name"
      />
      <div onInput={trimUnusedCharacters}>
        <TextInputBase
          value={formLinkSlug}
          onNameChange={e => updateFormLinkSlug(e.target.value)}
          inputName="Link slug "
          placeholder="Link slug name"
          errorMessage={formLinkSlugError}
          validateInput={validateLinkSlug}
        />
      </div>
      <PageSelector {...pageSelectorProps} />
      <div className="landing-page-properties__link">
        Link
        <div>
          <a
            href={formLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {formLink}
          </a>
        </div>
      </div>
    </div>)
}

export default LandingPageProperties;
